import { ChangeEvent, Fragment } from 'react';

import { Modal } from '../../shared';

import {
    BannerPositionPlacement,
    BannerPositionScene,
    BannerSceneDisplayName,
    BannerType,
    PossiblePlacementByScene,
} from '../../types/enums/bannerType.enum';

import { Banner } from '../../types/bannerTypes';

export const BannerPlacementDisplayName = {
    [BannerPositionPlacement.TOP_LEFT]: 'Top Left',
    [BannerPositionPlacement.TOP_RIGHT]: 'Top Right',
    [BannerPositionPlacement.SCENE_SPECIFIC]: 'Scene Specific',
    [BannerPositionPlacement.FIRST_SELECT_ITEM]: 'First Item',
    [BannerPositionPlacement.LAST_SELECT_ITEM]: 'Last Item',
    [BannerPositionPlacement.BUTTON_RIGHT]: 'Button Right',
};

export const BannerTypeDisplayName = {
    [BannerType.LANDSCAPE_SPEECH_BUBBLE]: 'Speech bubble',
    [BannerType.ONBOARDING_SPEECH_BUBBLE]: 'Onboarding',
};

type BannerLocationSelectorProps = {
    isNew: boolean;
    scene: Banner['positionScene'];
    placement: Banner['positionPlacement'];
    type: Banner['type'];
    onPlacementChange: (event: ChangeEvent<HTMLInputElement>) => void;
    onSceneChange: (event: ChangeEvent<HTMLInputElement>) => void;
    onTypeChange: (event: ChangeEvent<HTMLInputElement>) => void;
};

export const BannerLocationSelector = (props: BannerLocationSelectorProps) => {
    const { isNew, scene, placement, type, onPlacementChange, onTypeChange } =
        props;

    const onSceneChange = async (event: ChangeEvent<HTMLInputElement>) => {
        if (event.target.value === scene) {
            return;
        }

        event.preventDefault();

        const isConfirmed = await Modal.confirm({
            heading: 'Change banner location?',
            text: 'Warning! This will discard any input made or media uploaded',
            okLabel: 'Yes, change',
            cancelLabel: 'Cancel',
        });

        if (!isConfirmed) return;

        props.onSceneChange(event);
    };

    const placements = PossiblePlacementByScene[scene];

    return (
        <>
            <fieldset>
                <legend>Select banner location</legend>
                {Object.values(BannerPositionScene).map((option) => (
                    <Fragment key={option}>
                        <input
                            checked={scene === option}
                            disabled={!isNew}
                            id={option}
                            name="positionScene"
                            type="radio"
                            value={option}
                            onChange={onSceneChange}
                        />
                        <label htmlFor={option}>
                            {BannerSceneDisplayName[option]}
                        </label>
                    </Fragment>
                ))}
            </fieldset>
            {placements.length > 1 && (
                <fieldset>
                    <legend>Select banner placement</legend>
                    {Object.values(placements).map((option) => (
                        <Fragment key={option}>
                            <input
                                checked={placement === option}
                                id={option}
                                name="positionPlacement"
                                type="radio"
                                value={option}
                                onChange={onPlacementChange}
                            />
                            <label htmlFor={option}>
                                {BannerPlacementDisplayName[option]}
                            </label>
                        </Fragment>
                    ))}
                </fieldset>
            )}
            {scene === BannerPositionScene.WORLD_MAP && (
                <fieldset>
                    <legend>Select banner type</legend>
                    <input
                        checked={type === BannerType.ONBOARDING_SPEECH_BUBBLE}
                        id={BannerType.ONBOARDING_SPEECH_BUBBLE}
                        name="type"
                        type="radio"
                        value={BannerType.ONBOARDING_SPEECH_BUBBLE}
                        onChange={onTypeChange}
                    />
                    <label htmlFor={BannerType.ONBOARDING_SPEECH_BUBBLE}>
                        {
                            BannerTypeDisplayName[
                                BannerType.ONBOARDING_SPEECH_BUBBLE
                            ]
                        }
                    </label>
                    <input
                        checked={type === BannerType.LANDSCAPE_SPEECH_BUBBLE}
                        id={BannerType.LANDSCAPE_SPEECH_BUBBLE}
                        name="type"
                        type="radio"
                        value={BannerType.LANDSCAPE_SPEECH_BUBBLE}
                        onChange={onTypeChange}
                    />
                    <label htmlFor={BannerType.LANDSCAPE_SPEECH_BUBBLE}>
                        {
                            BannerTypeDisplayName[
                                BannerType.LANDSCAPE_SPEECH_BUBBLE
                            ]
                        }
                    </label>
                </fieldset>
            )}
        </>
    );
};
